import { Group, Stack, Space, Checkbox } from "@mantine/core";
import { Text } from "@/components/ui/Text";

import { AssignmentItemTimeProgress } from "./AssignmentItemTimeProgress";
import { IconArrowRight } from "@tabler/icons-react";
import { Link } from "../ui/Link";

export const TotalTimeCheckbox = ({
  isSmall = false,
  isCompleted = false,
  isExportView = false,
  totalSecondsWatchedByUser,
  totalMinutesToComplete,
}: {
  isSmall?: boolean;
  isCompleted?: boolean;
  isExportView?: boolean;
  totalSecondsWatchedByUser: number;
  totalMinutesToComplete: number;
}) => {
  return (
    <Stack gap={4} w="100%" flex={1}>
      <Group
        flex={1}
        gap={0}
        // opacity={isCompleted ? 0.7 : 1}
        align="center"
        w="100%"
      >
        <Checkbox
          color="primary"
          size={isSmall ? "xs" : "md"}
          readOnly
          checked={isCompleted}
        />
        <Space w="md" />
        <Stack flex={1} gap={0}>
          <Group
            gap={0}
            pl={isSmall ? 4 : 8}
            flex={1}
            justify="flex-start"
            w="100%"
          >
            <Text titleStyle={isSmall ? "h6" : "h5"} fw={500}>
              Watch at least{" "}
              <span style={{ fontWeight: 700 }}>
                {totalMinutesToComplete} minutes
              </span>{" "}
              of Advizer videos
            </Text>
            {isSmall ? null : (
              <>
                <Space w="md" />
                <Link to="/" target="_blank" style={{ fontSize: 13 }}>
                  <Group gap={4}>
                    Explore videos <IconArrowRight size={16} />
                  </Group>
                </Link>
              </>
            )}
          </Group>
          <Space h={4} />
        </Stack>
      </Group>

      <Group
        flex={1}
        justify="space-between"
        wrap="nowrap"
        pl={isSmall ? "xl" : 48}
        pt={isExportView ? 8 : undefined}
        w="100%"
      >
        <AssignmentItemTimeProgress
          totalSecondsWatched={totalSecondsWatchedByUser}
          totalSecondsRequired={totalMinutesToComplete * 60}
          isSmall={isSmall}
        />
      </Group>
    </Stack>
  );
};
